import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Product1 } from "../constant/Index";
import About from "../Pages/About/About";
import ApplyForLoan from "../Pages/applyforloan/ApplyForLoan";
import ApplyForLoans from "../Pages/applyforloan2/ApplyForLoan2";

import CreateNewPassword from "../Pages/auth/CreateNewPassword";
import ForgotPassword from "../Pages/auth/ForgotPassword";
import Login from "../Pages/auth/Login";
import Signup from "../Pages/auth/Signup";
import CompleteYourProfile from "../Pages/completeyourprofile/CompleteYourProfile";
import ContactUs from "../Pages/contact/ContactUs";
import Faqs from "../Pages/Faqs/Faqs";
import Home from "../Pages/Home/Home";
import Privacy from "../Pages/Privacypolicy/Privacy";
import Productagain from "../Pages/Products/Productagain";
import Productdetail from "../Pages/Products/Productdetail";
import Products from "../Pages/Products/Products";
import Account from "../Pages/ProfilePages/Account";
import DriverProfile from "../Pages/ProfilePages/DriverProfile";
import EditDriverDetail from "../Pages/ProfilePages/EditDriverDetail";
import EditPassword from "../Pages/ProfilePages/EditPassword";
import EditPersonalDetail from "../Pages/ProfilePages/EditPersonalDetail";
import LoanApplicaitonInterests from "../Pages/ProfilePages/LoanApplicationStatus";
import MyInterests from "../Pages/ProfilePages/MyInterests";
import InnerServices from "../Pages/Services/InnerServices";
import Services from "../Pages/Services/Services";
import Private from "./Private.js";
import Public from "./Public.js";
import Terms from "../Pages/Termsconditions/Terms";
import ProductInterestDetails from "../Pages/Products/ProductInterestDetails";

const AllRoutes = () => {
	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route
						path="/login"
						element={
							<Public>
								<Login />
							</Public>
						}
					/>
					<Route
						path="/Signup"
						element={
							<Public>
								<Signup />
							</Public>
						}
					/>
					<Route
						path="/ForgotPassword"
						element={
							<Public>
								<ForgotPassword />
							</Public>
						}
					/>
					<Route
						path="/CreateNewPassword"
						element={
							<Public>
								<CreateNewPassword />
							</Public>
						}
					/>
					<Route path="/contact" element={<ContactUs />} />
					<Route path="/products" element={<Products />} />
					<Route path="/productagain" element={<Productagain />} />
					<Route path="/productdetail/:id" element={<Productdetail />} />
					<Route
						path="/ProductInterestDetails/:id"
						element={<ProductInterestDetails />}
					/>
					<Route path="/services" element={<Services />} />
					<Route path="/innerservices/:id" element={<InnerServices />} />
					<Route path="/faqs" element={<Faqs />} />
					<Route path="/terms" element={<Terms />} />
					<Route path="/privacy" element={<Privacy />} />
					<Route path="/about" element={<About />} />
					<Route path="*" element={<Home />} />
					<Route
						path="/account"
						element={
							<Private>
								<Account />
							</Private>
						}
					/>
					<Route
						path="/edit-account"
						element={
							<Private>
								<EditPersonalDetail />
							</Private>
						}
					/>
					<Route
						path="/edit-password"
						element={
							<Private>
								<EditPassword />
							</Private>
						}
					/>
					<Route
						path="/driver-profile"
						element={
							<Private>
								<DriverProfile />
							</Private>
						}
					/>
					<Route
						path="/edit-driver-profile"
						element={
							<Private>
								<EditDriverDetail />
							</Private>
						}
					/>
					<Route
						path="/my-interest"
						element={
							<Private>
								<MyInterests />
							</Private>
						}
					/>
					<Route
						path="/loan-application"
						element={
							<Private>
								<LoanApplicaitonInterests />
							</Private>
						}
					/>

					<Route
						path="/applyforloan"
						element={
							<Private>
								<ApplyForLoan />
							</Private>
						}
					/>
					<Route
						path="/applyforloans"
						element={
							<Private>
								<ApplyForLoans />
							</Private>
						}
					/>
					<Route
						path="/completeyourprofile"
						element={
							<Private>
								<CompleteYourProfile />
							</Private>
						}
					/>
				</Routes>
			</BrowserRouter>
		</>
	);
};

export default AllRoutes;
